<template>
  <div class="container" id="container">
    <div class="myActivity">
      <div class="header ay-header">
        <h3 class="header-nav">
           个人信息
        </h3>
        <a href="javascript:;" class="icon-back" @clcik="backFn"></a>
      </div>
    </div>
    <div class="page js_show home">
      <div class="page__bd">
        <div class="weui-cells">
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>头像</p>
            </div>
            <div class="weui-cell__ft">
              <img src="../../../static/dist/img/sds.png" class="user_head" alt="">
            </div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>昵称</p>
            </div>
            <div class="weui-cell__ft">央视网友drweqr遥</div>
          </a>
        </div>
        <!--weui-cells end-->
        <div class="weui-cells">
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>真实姓名</p>
            </div>
            <div class="weui-cell__ft">王新</div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>性别</p>
            </div>
            <div class="weui-cell__ft">女</div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>手机号</p>
            </div>
            <div class="weui-cell__ft">180****3698</div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>所属地区</p>
            </div>
            <div class="weui-cell__ft">北京市  北京市  海淀区</div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>详细地址</p>
            </div>
            <div class="weui-cell__ft">街道门牌信息</div>
          </a>
   <!--       <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
              <p>更多</p>
            </div>
            <div class="weui-cell__ft">
            </div>
          </a>-->
        </div>
        <!--weui-cells end-->
      </div>
      <!--page__bd end-->
    </div>
  </div>
</template>

<script>
export default {
  data (){
    return {

    }
  },
  methods: {
      //操作按钮事件
    backFn(){
      $('#container').hide()
    }
  },
  created: function(){
    var that = this;
    this.$http.get(API.ShowActivityUser)
      .then(function (res) {
        console.log(res)
        if(res.code == 0){
          if(res.data.content){
            that.myMessage =  JSON.parse(res.data.content)
            if(that.myMessage && that.myMessage.address){
              that.address = that.myMessage.address
            }else{
              that.address = ''
            }
          }
        }
      })
  },
  mounted: function () {
      //操作DOM
  }

}
</script>

<style>
  #container{
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #fff;
    z-index: 999;
  }
  #container a{
    text-decoration: none;
  }
  #container .ay-header{

  }
  #container .header-nav{
    text-align: center;
  }
  #container .icon-back{
    margin-top: -20px;;
  }
  #container .page{
    padding-top: 40px;
    overflow-y: auto;
    z-index: 1;
    max-width: 414px;
    margin: 0 auto;
    background: #efeff4;
  }
  #container .weui-cells {
    margin-top: 1.17647059em;
    background-color: #FFFFFF;
    line-height: 1.47058824;
    font-size: 17px;
    overflow: hidden;
    position: relative;
  }
  #container .page.home .weui-cell {
    padding-left: 20px;
    padding-right: 20px;
  }
  #container .weui-cell_access {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    color: inherit;
  }
  #container .weui-cell:before {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #e5e5e5;
    color: #e5e5e5;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    left: 15px;
    z-index: 2;
  }
  #container .weui-cell {
    padding: 10px 15px;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  #container .weui-cell__bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    min-width: 80px;
  }
  #container .page.home .page__bd img.user_head {
    width: 63px;
    height: 63px;
    border-radius: 50%;
    border: 1px solid #b4b4b4;
    vertical-align: -5px;
  }
  #container .weui-cell__bd p {
    margin: 0 0 11px;
  }
  #container .weui-cell_access .weui-cell__ft {
    padding-right: 13px;
    position: relative;
  }
  #container .weui-cell_access .weui-cell__ft:after {
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #C8C8CD;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
  }
  #container .weui-cell__ft {
    text-align: left;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/myMessage/userContenr.vue